export default __webpack_public_path__ + "static/media/gear-17px-26282A.40af7e05.svg";